const navButton = document.getElementById('main-header__nav-button');
const navWrapper = document.getElementById('main-header__nav-wrapper');
let previousWindowSize = window.innerWidth; // eslint-disable-line no-unused-vars
let resizeTimer; // eslint-disable-line no-unused-vars

const headerResize = () => {
	document.body.classList.add('resizing');
	previousWindowSize = window.innerWidth;

	resizeTimer = setTimeout(function () {
		document.body.classList.remove('resizing');
	}, 400);
};

const header = () => {
	if (navButton && navWrapper) {
		navButton.addEventListener('click', toggleNav);
	}
};

const toggleNav = (e) => {
	e.preventDefault();

	navButton.classList.toggle('active');

	if (navButton.classList.contains('active')) {
		navWrapper.setAttribute('tabindex', 0);
		document.body.classList.add('lock-scroll');
	} else {
		navWrapper.setAttribute('tabindex', -1);
		document.body.classList.remove('lock-scroll');
	}
};

export { header, headerResize };
